import { timeRangeValues } from '../TimeRangeSelect/constants'

export const getDateFormatted = date => {
  if (!date || isNaN(date?.getTime())) {
    return ''
  }
  return `${date?.getFullYear()}-${date?.getMonth() + 1}-${date?.getDate()}`
}

export const getFilters = (filters, timeRange) => {
  const filtersResult = {
    ...filters,
    timeRange,
  }

  if (timeRange !== timeRangeValues.custom) {
    delete filtersResult?.startDate
    delete filtersResult?.endDate
  }

  return filtersResult
}
